/** IANA timezone for the transit network — all rider-facing times render here. */
const BERLIN_TZ = 'Europe/Berlin';

const HHMM_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: BERLIN_TZ,
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const HHMMSS_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: BERLIN_TZ,
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

/** Formats `date` as `HH:MM` in Berlin time. */
export function formatHHMM(date: Date): string {
  return HHMM_FORMATTER.format(date);
}

/** Formats `date` as `HH:MM:SS` in Berlin time. */
export function formatHHMMSS(date: Date): string {
  return HHMMSS_FORMATTER.format(date);
}

/**
 * Returns the current wall-clock time in Berlin as `HH:MM`. The `new Date()`
 * call lives here (not inside {@link formatHHMM}) so tests can stub the clock
 * via `vi.setSystemTime` without mocking the formatter.
 */
export function nowHHMM(): string {
  return formatHHMM(new Date());
}
